  <main>
<div class="container-fluid">
<h1 class="mt-4">Orders</h1>
<ol class="breadcrumb mb-4">
  <li class="breadcrumb-item active">Orders</li>
</ol>
<div class="clearfix"></div>
<div class="col-12 mb-4 actions">
  <div class="float-left">
    <button type="button" class="btn-custom btn-outline-info-custom mr-1"
            (click)="toggleQuickFilter('isNeedSellerCheck')" [class.active]="query.isNeedSellerCheck"
            *ngIf="userData.roles.indexOf('Designer') == -1"
            >
      <i class="fas fa-user-check"></i>
      Cần Seller check
      <span class="badge badge-info">{{filterCount.needSellerCheckCount}}</span>
    </button>
    <button type="button" class="btn-custom btn-outline-danger-custom mr-1" (click)="toggleQuickFilter('isNoticed')"
            [class.active]="query.isNoticed">
      <i class="fas fa-flag"></i>
      Cần Xác Minh
      <span class="badge badge-danger">{{filterCount.needConfirmCount}}</span>
    </button>
    <button type="button" class="btn-custom btn-outline-warning-custom mr-1"
            (click)="toggleQuickFilter('isNeedFindLink')" [class.active]="query.isNeedFindLink">
      <i class="fas fa-paint-roller"></i>
      Cần Design
      <span class="badge badge-warning">{{filterCount.needDesignCount}}</span>
    </button>
    <button type="button" class="btn-custom btn-outline-info-custom mr-1"
            (click)="toggleQuickFilter('isNeedFulfill')" [class.active]="query.isNeedFulfill"
            *ngIf="userData.roles.indexOf('Designer') == -1">
      <i class="fas fa-cash-register"></i>
      Cần Fulfill
      <span class="badge badge-info">{{filterCount.needFulfillCount}}</span>
    </button>
    <button type="button" class="btn btn-outline-success mr-1" (click)="toggleQuickFilter('isNeedShip')"
            [class.active]="query.isNeedShip"
            *ngIf="userData.roles.indexOf('Designer') == -1">
      <i class="fas fa-truck-loading"></i>
      Đợi Tracking
      <span class="badge badge-success">{{filterCount.waitTrackCount}}</span>
    </button>
    <button type="button" class="btn btn-outline-primary mr-1"
            (click)="toggleQuickFilter('isNeedAddTrackToAccount')" [class.active]="query.isNeedAddTrackToAccount"
            *ngIf="userData.roles.indexOf('Designer') == -1">
      <i class="fas fa-truck-loading"></i>
      Cần Add Track TK
      <span class="badge badge-primary">{{filterCount.needAddTrackToAccountCount}}</span>
    </button>
    <button type="button" class="btn btn-outline-primary mr-1" (click)="toggleQuickFilter('isFollowTrack')"
            [class.active]="query.isFollowTrack"
            *ngIf="userData.roles.indexOf('Designer') == -1">
      <i class="fas fa-truck"></i>
      Đang theo dõi tracking
      <span class="badge badge-primary">{{filterCount.followTrackCount}}</span>
    </button>
    <button type="button" class="btn-custom btn-outline-info-custom mr-1" [class.active]="query.isDone"
            (click)="toggleQuickFilter('isDone')"
            *ngIf="userData.roles.indexOf('Designer') == -1">
      <i class="fas fa-check-square"></i>
      Done
    </button>
  </div>
</div>
<div class="clearfix"></div>
<div class="col-12 mt-10 mb-4 actions">
  <div class="float-right">
    <button type="button" class="btn btn-sm btn-primary mr-1" (click)="openImportSaleRecordModal()"
            *ngIf="
                userData.isAdmin
                || userData.isSuperAdmin
                || userData.roles.indexOf('Team Leader')>
          -1
          || userData.roles.indexOf('Seller') > -1
          || userData.roles.indexOf('Support') > -1"
    >
      <i class="fas fa-cloud-upload-alt"></i>
      Import Đơn Ebay/Etsy
    </button>
    <button type="button" class="btn btn-sm btn-primary mr-1" (click)="downloadExportFileForMerchize()"
            *ngIf="
                userData.isAdmin
                || userData.isSuperAdmin
                || userData.roles.indexOf('Team Leader')>
          -1
          || userData.roles.indexOf('Seller') > -1
          || userData.roles.indexOf('Fulfill') > -1"
    >
      <i class="fas fa-ruler-combined"></i>
      Export Merchize
    </button>

    <button type="button" class="btn btn-sm btn-primary mr-1" (click)="preConfirmBuyApi('flashship')"
            *ngIf="userData.roles.indexOf('Designer') == -1">
      <i class="fa fa-rocket" aria-hidden="true"></i>
      Mua Flashship - Api
    </button>

    <button type="button" class="btn btn-sm btn-primary mr-1" (click)="preConfirmBuyApi('Onos')"
            *ngIf="userData.roles.indexOf('Designer') == -1">
      <i class="fa fa-rocket" aria-hidden="true"></i>
      Mua Onos - Api
    </button>

    <button type="button" class="btn btn-sm btn-primary mr-1" (click)="preConfirmBuyApi('ISO')"
            *ngIf="userData.roles.indexOf('Designer') == -1">
      <i class="fa fa-rocket" aria-hidden="true"></i>
      Mua ISO - Api
    </button>

    <button type="button" class="btn btn-sm btn-primary mr-1" (click)="preConfirmBuyApi('Printposs')"
            *ngIf="userData.roles.indexOf('Designer') == -1">
      <i class="fa fa-rocket" aria-hidden="true"></i>
      Mua Printposs - Api
    </button>

    <button type="button" class="btn btn-sm btn-primary mr-1" (click)="preConfirmBuyApi('bestPrintCare')"
            *ngIf="userData.roles.indexOf('Designer') == -1">
      <i class="fa fa-rocket" aria-hidden="true"></i>
      Mua Best Print Care - Api
    </button>

    <button type="button" class="btn btn-sm btn-primary mr-1" (click)="preConfirmBuyApi('monkeyKingPrint')"
            *ngIf="userData.roles.indexOf('Designer') == -1">
      <i class="fa fa-rocket" aria-hidden="true"></i>
      Mua Monkey King - Api
    </button>

    <button type="button" class="btn btn-sm btn-primary mr-1" (click)="preConfirmBuyApi('Gearment')"
            *ngIf="userData.roles.indexOf('Designer') == -1">
      <i class="fa fa-rocket" aria-hidden="true"></i>
      Mua Gearment - Api
    </button>

    <button type="button" class="btn btn-sm btn-primary mr-1" (click)="preConfirmBuyApi('ATD')"
            *ngIf="userData.roles.indexOf('Designer') == -1">
      <i class="fa fa-rocket" aria-hidden="true"></i>
      Mua ATD - Api
    </button>

    <button type="button" class="btn btn-sm btn-primary mr-1" (click)="preConfirmBuyApi('Zenith')"
            *ngIf="userData.roles.indexOf('Designer') == -1">
      <i class="fa fa-rocket" aria-hidden="true"></i>
      Mua Zenith - Api
    </button>

    <button type="button" class="btn btn-sm btn-primary mr-1" (click)="downloadExportFileForBestPrintCare()"
            *ngIf="
                userData.isAdmin
                || userData.isSuperAdmin
                || userData.roles.indexOf('Team Leader')>
          -1
          || userData.roles.indexOf('Seller') > -1
          || userData.roles.indexOf('Fulfill') > -1"
    >
      <i class="fas fa-ruler-combined"></i>
      Export Best Print Care
    </button>

    <button type="button" class="btn btn-sm btn-primary mr-1" (click)="downloadExportFileForGke()"
            *ngIf="
                userData.isAdmin
                || userData.isSuperAdmin
                || userData.roles.indexOf('Team Leader')>
          -1
          || userData.roles.indexOf('Seller') > -1
          || userData.roles.indexOf('Fulfill') > -1"
    >
      <i class="fas fa-ruler-combined"></i>
      Export GKE Logistic
    </button>

    <button type="button" class="btn btn-sm btn-primary mr-1" (click)="downloadExportFileForPrintify()"
            *ngIf="
                userData.isAdmin
                || userData.isSuperAdmin
                || userData.roles.indexOf('Team Leader')>
          -1
          || userData.roles.indexOf('Seller') > -1
          || userData.roles.indexOf('Fulfill') > -1"
    >
      <i class="fas fa-ruler-combined"></i>
      Export Printify Shirts
    </button>

    <button type="button" class="btn btn-sm btn-primary mr-1" (click)="preConfirmBuyApi('printify')"
            *ngIf="userData.roles.indexOf('Designer') == -1">
      <i class="fa fa-rocket" aria-hidden="true"></i>
      Mua Printify - Api
    </button>

    <button type="button" class="btn btn-sm btn-primary mr-1" (click)="preConfirmBuyApi('Hd Sticker')"
            *ngIf="userData.roles.indexOf('Designer') == -1">
      <i class="fa fa-rocket" aria-hidden="true"></i>
      Mua HD Sticker - Api
    </button>

    <button type="button" class="btn btn-sm btn-primary mr-1" (click)="preConfirmBuyApi('Tero')"
            *ngIf="userData.roles.indexOf('Designer') == -1">
      <i class="fa fa-rocket" aria-hidden="true"></i>
      Mua Tero - Api
    </button>

    <button type="button" class="btn btn-sm btn-primary mr-1" (click)="preConfirmBuyApi('HoGoToPod')"
            *ngIf="userData.roles.indexOf('Designer') == -1">
      <i class="fa fa-rocket" aria-hidden="true"></i>
      Mua HoGoToPod - Api
    </button>

    <button type="button" class="btn btn-sm btn-primary mr-1" (click)="clearFilter()">
      <i class="fas fa-eraser"></i>
      Clear Filter
    </button>

    <button type="button" class="btn btn-sm btn-primary" (click)="querySaleRecords()">
      <i class="fas fa-redo"></i>
      Refresh Table
    </button>
  </div>
  <div class="clearfix"></div>
</div>
<div class="table-responsive order-table">
<table class="table table-bordered table-hover">
<tr>
  <th class="text-center" width="40px"></th>
  <th class="text-center" width="100px">Buy/Ship Date</th>
  <th class="text-center" width="143px">Source Order Id</th>
  <th width="150px">Customer Name</th>
  <th class="text-center" width="135px">SKU</th>
  <th class="text-right" width="85px">Customer Charged</th>
  <th class="text-center" width="143px">Destination Order Id</th>
  <th class="text-right" width="85px">Product Price</th>
  <th class="text-right" width="85px">Order Price</th>
  <th width="205px">Tracking</th>
  <th>Note</th>
  <th class="text-right" width="85px">Order Refund</th>
  <th width="205px">Account</th>
  <th width="150px">Actions</th>
</tr>
<tr>
  <th class="text-center">
    <label>
      <input type="checkbox" [(ngModel)]="checkAll" (click)="toggleCheckAll()">
    </label>
  </th>
  <th class="text-center">
    <input class="form-control form-control-sm" [owlDateTimeTrigger]="purchaseDate" [owlDateTime]="purchaseDate"
           [(ngModel)]="query.purchaseDate" (ngModelChange)="querySaleRecords(1)" placeholder="Buy Date">
    <owl-date-time [pickerType]="'calendar'" #purchaseDate></owl-date-time>
    <input class="form-control form-control-sm" [owlDateTimeTrigger]="shipDueDate" [owlDateTime]="shipDueDate"
           [(ngModel)]="query.shipDueDate" (ngModelChange)="querySaleRecords(1)" placeholder="Ship Date">
    <owl-date-time [pickerType]="'calendar'" #shipDueDate></owl-date-time>
  </th>
  <th class="text-center">
    <input class="form-control form-control-sm" [(ngModel)]="query.sourceOrderId"
           (ngModelChange)="querySaleRecords(1)" placeholder="Source Order Id">
  </th>
  <th>
    <input class="form-control form-control-sm" [(ngModel)]="query.customerName"
           (ngModelChange)="querySaleRecords(1)" placeholder="Customer Name">
  </th>
  <th class="text-center">
    <input class="form-control form-control-sm" [(ngModel)]="query.sku" (ngModelChange)="querySaleRecords(1)"
           placeholder="SKU">
  </th>
  <th class="text-right"></th>
  <th class="text-center">
    <input class="form-control form-control-sm" [(ngModel)]="query.destinationOrderId"
           (ngModelChange)="querySaleRecords(1)" placeholder="Destination Order Id">
    <select class="form-control" [(ngModel)]="query.wantedPrintService" (ngModelChange)="querySaleRecords(1)">
      <option value="" selected>Toàn bộ nhà in</option>
      <option value="ATD">ATD</option>
      <option value="Flashship">Flashship</option>
      <option value="Gearment">Gearment</option>
      <option value="Hd Sticker">Hd Sticker</option>
      <option value="HoGoToPod">HoGoToPod</option>
      <option value="ISO">ISO</option>
      <option value="Merchize">Merchize</option>
      <option value="Onos">Onos</option>
      <option value="OP Creative">OP Creative</option>
      <option value="PrintArrow">Print Arrow</option>
      <option value="Printcare">Printcare</option>
      <option value="Printify">Printify</option>
      <option value="Printposs">Printposs</option>
      <option value="Tero">Tero</option>
      <option value="VTP">VTP</option>
      <option value="Zenith">Zenith</option>
      <option value="Nhà in khác">Nhà in khác</option>
    </select>
  </th>
  <th class="text-right"></th>
  <th class="text-right"></th>
  <th>
    <input class="form-control form-control-sm" [(ngModel)]="query.trackingNumber"
           (ngModelChange)="querySaleRecords(1)" placeholder="Tracking">
  </th>
  <th>
    <input class="form-control form-control-sm" [(ngModel)]="query.note" (ngModelChange)="querySaleRecords(1)"
           placeholder="Note">
  </th>
  <th class="text-right"></th>
  <th>
    <ng-select [items]="merchants" 
               [multiple]="true"
               class="table-select-filter"
               placeholder="Toàn bộ tài khoản"
               bindValue="merchantId"
               bindLabel="name"
               [closeOnSelect]="false"
               (close)="querySaleRecords(1)"
               (clear)="querySaleRecords(1)"
               [(ngModel)]="query.merchantIds">
      <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
        <input id="item-{{index}}" type="checkbox" [ngModel]="item$.selected"/> {{item.name}}
                </ng-template>  
    </ng-select>
  </th>
  <th>
  </th>
</tr>
<tbody>
  <tr *ngFor="let record of saleRecords" [class.warning]="record.isScamWarning">
    <td class="text-center">
      <label>
        <input type="checkbox" [(ngModel)]="record.isSelected">
      </label>
    </td>
    <td class="text-center">
      {{record.purchaseDate}}
      <br />
      {{record.shipDueDate}}
      <br />

      <span class="badge badge-pill badge-primary" *ngIf="record.isPrepaidLabel">
        Prepaid
      </span>

      <br/>
      <app-buy-tiktok-label [saleRecord]="record" (buyLabelDone)="querySaleRecords()"></app-buy-tiktok-label>

    </td>
    <td class="text-center can-copy" ngxClipboard [cbContent]="record.sourceOrderId"
        (cbOnSuccess)="onCoppied(record, 'sourceOrderId')" [class.coppied]="record.sourceOrderIdCoppied">
      <span>{{record.sourceOrderId}}</span>
      <br />
      <b>{{getCustomization(record.customizeInfo, 1)}}</b>
      <br />
      <b>{{getCustomization(record.customizeInfo, 4)}}</b>
    </td>
    <td class="can-copy" ngxClipboard [cbContent]="record.customerName"
        (cbOnSuccess)="onCoppied(record, 'customerName')" [class.coppied]="record.customerNameCoppied">
      <span>{{record.customerName}}</span>
      <br />
      <b>{{getCustomization(record.customizeInfo, 2)}}</b>
      <br />
      <b>{{getCustomization(record.customizeInfo, 5)}}</b>
    </td>
    <td class="text-center can-copy" ngxClipboard [cbContent]="record.sku"
        (cbOnSuccess)="onCoppied(record, 'asin')" [class.coppied]="record.asinCoppied">
      {{record.sku}} (Q - {{record.productQuantity}})
      <br />
      <b>{{getCustomization(record.customizeInfo, 3)}}</b>
      <br />
      <b>{{getCustomization(record.customizeInfo, 6)}}</b>
    </td>
    <td class="text-right">
      ${{record.customerChargedTotal}}
      <br />
      <a href="{{record.productLink}}" target="_blank"><i class="fas fa-eye fa-lg"></i></a>
      <a class="ml-2" href="javascript:void(0)" (click)="copyHeading(record)"><i
                                                                                class="fas fa-heading fa-lg"></i></a>
      <a class="ml-2" href="javascript:void(0)" (click)="copyOrderData(record)"><i
                                                                                  class="fas fa-copy fa-lg"></i></a>

    </td>
    <td class="text-center">
      <span class="can-copy" (cbOnSuccess)="onCoppied(record, 'destinationOrderId')" ngxClipboard
            [cbContent]="record.destinationOrderId" [class.coppied]="record.destinationOrderIdCoppied">
        {{record.destinationOrderId}}                
              </span>
      <br />
      <span class="badge badge-pill badge-info" 
            *ngIf="record.wantedPrintService != undefined 
                      && record.wantedPrintService != null 
                      && record.wantedPrintService != ''">
        {{record.wantedPrintService}}
              </span>
    </td>
    <td class="text-right" ngxClipboard [cbContent]="record.productPrice"
        (cbOnSuccess)="onCoppied(record, 'productPrice')" [class.coppied]="record.productPriceCoppied">
      {{record.productPrice}}
            </td>
    <td class="text-right" ngxClipboard [cbContent]="record.orderPrice"
        (cbOnSuccess)="onCoppied(record, 'orderPrice')" [class.coppied]="record.orderPriceCoppied">
      {{record.orderPrice}}
            </td>
    <td ngxClipboard [cbContent]="record.TrackingNumber" (cbOnSuccess)="onCoppied(record, 'TrackingNumber')"
        [class.coppied]="record.trackingNumberCoppied">
      {{record.trackingNumber}}
            </td>
    <td>
      <app-editable [data]="record.note" [dataType]="'textarea'"
                    (focusOut)="updateSingleValue(record, 'Note', $event)"></app-editable>
    </td>
    <td class="text-right">
      <app-editable [data]="record.orderRefund" [dataType]="'number'"
                    (focusOut)="updateSingleValue(record, 'OrderRefund', $event)"></app-editable>
    </td>
    <td>
      {{record.merchantName}}
              <br />
      ({{record.channel}})
      <br />
      <br />

      <span *ngIf="record.sellerName != undefined">
        Seller: <strong>{{record.sellerName}}</strong>
      </span> <br />
      <span *ngIf="record.designerName != undefined">
        Designer: <strong>{{record.designerName}}</strong>
      </span>               
    </td>
    <td class="saler-record-actions-container">
      <div class="text-center">
        <button class="btn-custom btn-outline-info-custom" (click)="openProductLinkModal(record)"
                [class.active]="record.progressState == 0" [disabled]="record.progressState != 0"
                *ngIf="userData.roles.indexOf('Designer') == -1">
          <i class="fas fa-user-check"></i>
        </button>

        <button class="btn-custom btn-outline-warning-custom" (click)="openProductLinkModal(record)"
                [class.active]="record.progressState == 10" [disabled]="record.progressState != 10">
          <i class="fas fa-paint-roller"></i>
        </button>

        <button class="btn-custom btn-outline-info-custom" (click)="openProductLinkModal(record)"
                [class.active]="record.progressState == 20" [disabled]="record.progressState != 20"
                [class.text-red]="record.stillGetLink"
                *ngIf="userData.roles.indexOf('Designer') == -1">
          <i class="fas fa-cash-register"></i>
        </button>

        <br *ngIf="userData.roles.indexOf('Designer') == -1"/>
        <button class="btn-custom btn-outline-success-custom" (click)="openProductLinkModal(record)"
                [class.active]="record.progressState == 30" [disabled]="record.progressState != 30"
                *ngIf="userData.roles.indexOf('Designer') == -1">
          <i class="fas fa-truck-loading"></i>
        </button>

        <button class="btn-custom btn-outline-primary-custom" (click)="openProductLinkModal(record)"
                [class.active]="record.progressState == 35" [disabled]="record.progressState != 35"
                *ngIf="userData.roles.indexOf('Designer') == -1">
          <i class="fas fa-truck-loading"></i>
        </button>

        <button class="btn-custom btn-outline-primary-custom" (click)="openProductLinkModal(record)"
                [class.active]="record.progressState == 40" [disabled]="record.progressState != 40"
                *ngIf="userData.roles.indexOf('Designer') == -1">
          <i class="fas fa-truck"></i>
        </button>

        <button class="btn-custom btn-outline-info-custom" [class.active]="record.progressState == 50"
                (click)="openProductLinkModal(record)"
                *ngIf="userData.roles.indexOf('Designer') == -1">
          <i class="fas fa-check-square"></i>
        </button>

        <br />
        <button class="btn-custom btn-outline-secondary-custom"
                (click)="updateSingleValue(record, 'IsCanceled', $event)" [class.active]="record.isCanceled"
                *ngIf="userData.roles.indexOf('Designer') == -1">
          <i class="fas fa-times"></i>
        </button>

        <button class="btn-custom btn-outline-danger-custom" (click)="confirmDeleteSaleRecord(record)"
                [class.active]="record.isDeleted"
                *ngIf="userData.roles.indexOf('Designer') == -1">
          <i class="fas fa-trash"></i>
        </button>

        <button class="btn-custom btn-outline-danger-custom" (click)="openProductLinkModal(record)"
                [class.active]="record.progressState == 5" [disabled]="record.progressState != 5"
                *ngIf="userData.roles.indexOf('Designer') == -1">
          <i class="fas fa-flag"></i>
        </button>

        <select class="form-control mt-10 mb-1" [(ngModel)]="record.progressState"
                (ngModelChange)="updateSingleValue(record, 'ProgressState', record.progressState)">
          <option *ngFor="let p of progressStates" [value]="p.value">{{ p.name }}</option>
        </select>

      </div>

    </td>
  </tr>

</tbody>
</table>




<div class="float-right">
  <app-pagination [(pageNumber)]="query.pageNumber" [pageSize]="query.pageSize" [totalItems]="totalItem"
                  (onPageChanged)="querySaleRecords($event)">
  </app-pagination>
</div>
</div>
</div>
</main>

<app-confirm-action [confirmMessage]="confirmBuyApiMessage"
                    (action)="buyApiAction()"
                    [openModal]="openConfirmBuyApiAction">
</app-confirm-action>

<ng-template #productLinkModal let-modal>
<div class="productLinkModal actions-modal">
<div class="modal-header">
  <h4 *ngIf="sellerCheck.currentRecord.progressState == 0" class="modal-title" id="modal-basic-title">
    Seller Check
  </h4>
  <h4 *ngIf="sellerCheck.currentRecord.progressState == 5" class="modal-title" id="modal-basic-title">
    Cần xác minh
  </h4>
  <h4 *ngIf="sellerCheck.currentRecord.progressState == 10" class="modal-title" id="modal-basic-title">
    Upload Design
  </h4>
  <h4 *ngIf="sellerCheck.currentRecord.progressState == 20" class="modal-title" id="modal-basic-title">
    Điền thông
    tin Fulfill
  </h4>
  <h4 *ngIf="sellerCheck.currentRecord.progressState == 30" class="modal-title" id="modal-basic-title">
    Chờ Tracking
  </h4>
  <h4 *ngIf="sellerCheck.currentRecord.progressState == 35" class="modal-title" id="modal-basic-title">
    Add Track TK
  </h4>
  <h4 *ngIf="sellerCheck.currentRecord.progressState == 40" class="modal-title" id="modal-basic-title">
    Đang theo dõi
    Track
  </h4>
</div>

<div class="modal-body">
<div class="form-group">
<div class="col-12">
<div class="row">
<div class="col-6">
  <strong>SẢN PHẨM NGUỒN</strong>
  <strong class="ml-5">
    Đơn nguồn:
    {{sellerCheck.sourceProduct.sourceOrderId}}
          
  </strong>
  <strong class="ml-5">
    ACC: {{sellerCheck.sourceProduct.merchantName}}
          
  </strong>
  <br />
  <strong>SKU:</strong> {{sellerCheck.sourceProduct.sku}} <strong>(Qty: {{sellerCheck.sourceProduct.productQuantity}}) </strong>

  <strong>{{genSellerCheckCustomizeInfo(sellerCheck.sourceProduct.customizeInfo)}}</strong>
  <br />
  <strong>Tên: </strong>
  <a href="{{sellerCheck.sourceProduct.productLink}}" target="_blank">{{sellerCheck.sourceProduct.productName}}</a>
  <br />
  <img [src]="sellerCheck.sourceProduct.sourceImage" class="img-responsive" />
  <br />
  <strong>Link sản phẩm chọn: </strong>
  <span class="sellerCheckDownloadLink" *ngFor="let link of sellerCheck.downloadLinks; let i = index">
    <a [href]="link">Download {{i + 1}}</a>
  </span>
  <br />
  <textarea [disabled]="sellerCheck.currentRecord.progressState > 20" class="w-100"
                        [(ngModel)]="sellerCheck.destinationProductLinkText" (change)="genDownloadLinks()"></textarea>
  <br />

  <strong>Note:</strong> <br />
  <textarea class="w-100" [(ngModel)]="sellerCheck.sourceProduct.note" rows="3"></textarea><br />

  <div class="row no-padding-side left-actions">
    <div class="col-4 mt-36" *ngIf="sellerCheck.currentRecord.progressState != 5">
      <button class="btn btn-danger" (click)="passToNeedConfirm()">
        <i class="fas fa-flag"></i>
        Cần Xác Minh
      </button>
    </div>

    <div class="col-4 mt-36" *ngIf="sellerCheck.currentRecord.progressState != 0">
      <button class="btn btn-info" (click)="passToSeller()">
        <i class="fas fa-user-check"></i>
        Chuyển sang Seller
      </button>
    </div>

    <div class="col-4"
         *ngIf="sellerCheck.currentRecord.progressState != 10 && sellerCheck.currentRecord.progressState <=20">

      <ng-select class="text-left" [items]="sellerCheck.availableDesigners"
                 bindLabel="userName"
                 [(ngModel)]="sellerCheck.selectedDesigner">
      </ng-select>

      <button class="btn btn-warning" (click)="passToDesigner()">
        <i class="fas fa-paint-roller"></i>
        Chuyển Sang Designer
      </button>
    </div>

    <div class="col-4"
         *ngIf="sellerCheck.currentRecord.progressState != 20 && sellerCheck.currentRecord.progressState <=30">
      <ng-select class="text-left" [items]="sellerCheck.availablePrintServices"
                 placeholder="Nhà in"
                 (change)="updatePrintService(sellerCheck.sourceProduct.orderItemId ,sellerCheck.sourceProduct.wantedPrintService)"
                 [(ngModel)]="sellerCheck.sourceProduct.wantedPrintService">
      </ng-select>
      
      <button class="btn btn-info" (click)="passToFulfill()">
        <i class="fas fa-cash-register"></i>
        Chuyển Sang Fulfill
      </button>
    </div>
  </div>
  <div class="row no-padding-side">
    <div class="col-12 mt-10 saleRecordLogs">
      <p *ngFor="let log of saleRecordLogs">
        {{log.createdString}} - <span [innerHTML]="log.logMessage"></span>
      </p>
    </div>
  </div>
</div>

<div class="col-6">
<div class="suggestion" *ngIf="sellerCheck.currentRecord.progressState == 0">
  Có {{sellerCheck.suggestProducts.length}} đề xuất
  <span *ngFor="let product of sellerCheck.suggestProducts">
    <div class="image-place-holder-card"
         [class.isActive]="product.label == sellerCheck.selectedProduct?.label"
         *ngIf="!product.ignoredDes">
      <div class="c-header">
        {{product.label}}
                
        <a class="ignore-des" (click)="ignoreDes(product)">
          <i class="fas fa-times ignore-des"></i>
        </a>
      </div>
      <div class="c-body" (click)="selectSuggestProduct(product)">
        <img *ngFor="let link of product.demoLinks" [src]="link" class="placeholder  show-trans-image" />
      </div>
    </div>
  </span>
</div>
<br />
<div class="uploadDesign" *ngIf="sellerCheck.currentRecord.progressState <= 10">
  Upload file design
  <input #uploadDesInput [(ngModel)]="desImages" type="file" multiple="true" (change)="upload($event.target.files)">
</div>

<img class="loader" *ngIf="sellerCheck.uploadProgress" src="/content/loading.gif" />

<div class="mt-10" *ngFor="let demoImageLink of sellerCheck.selectedProduct?.demoLinks" [hidden]="temptPreviewImages.length > 0">
  <img [src]="demoImageLink == null ? global.imgHodlder : demoImageLink" class="img-responsive show-trans-image" />
</div>

<div class="mt-10" *ngFor="let demoImageLink of temptPreviewImages; let i = index" [hidden]="temptPreviewImages.length == 0">
  <div class="preview-container">
    <img [src]="demoImageLink == null ? global.imgHodlder : demoImageLink"
         class="img-responsive show-trans-image preview-image" />
  </div>
</div>

<div class="mt-10"
     *ngIf="sellerCheck.currentRecord.progressState >= 20 || sellerCheck.currentRecord.progressState == 5">
  <div class="form-group row">
    <label class="col-sm-2 col-form-label">Đơn nguồn</label>
    <div class="col-sm-10">
      {{sellerCheck.sourceProduct.sourceOrderId}}




    </div>
  </div>
  <div class="form-group row">
    <label class="col-sm-2 col-form-label">Sku</label>
    <div class="col-sm-10">
      {{sellerCheck.sourceProduct.sku}} <strong>(Qty {{sellerCheck.sourceProduct.productQuantity}})</strong>
      |
      <strong class="ml-2">{{genSellerCheckCustomizeInfo(sellerCheck.sourceProduct.customizeInfo)}}</strong>
    </div>
  </div>
  <div class="form-group row">
    <label class="col-sm-2 col-form-label">Khách hàng</label>
    <div class="col-sm-10">
      {{sellerCheck.sourceProduct.mobile}}<br />
      {{sellerCheck.sourceProduct.customerName}} <br />
      {{sellerCheck.sourceProduct.streetAddress}}<br />
      <span *ngIf="sellerCheck.sourceProduct.streetAddress2 != undefined && sellerCheck.sourceProduct.streetAddress2 != ''">
        {{sellerCheck.sourceProduct.streetAddress2}}<br />
      </span>
      {{sellerCheck.sourceProduct.city}}, {{sellerCheck.sourceProduct.state}}
      {{sellerCheck.sourceProduct.zipCode}}<br />{{sellerCheck.sourceProduct.channel}}<br />
    </div>
  </div>
  <div class="form-group row">
    <label class="col-sm-2 col-form-label">Id Đơn mua</label>
    <div class="col-sm-10">
      <input [disabled]="sellerCheck.currentRecord.progressState != 20" type="text" class="form-control"
             [(ngModel)]="sellerCheck.sourceProduct.destinationOrderId" />
    </div>
  </div>

  <div class="form-group row">
    <label class="col-sm-2 col-form-label">Xuất kho</label>
    <div class="col-sm-10">
      <app-inventory-output [inventoryProducts]="inventoryProducts"
                            [loading]="inventoryOutputLoading"
                            [error]="inventoryOutputError"
                            [orderItemId]="sellerCheck.sourceProduct.orderItemId"
                            (output)="onInventoryOutput($event, sellerCheck.sourceProduct)"
                            (delete)="onInventoryOutputDelete($event)">
      </app-inventory-output>
    </div>
  </div>
  <div class="form-group row">
    <label class="col-sm-2 col-form-label">Nhà in</label>
    <div class="col-sm-10">
      <ng-select class="text-left" [items]="sellerCheck.availablePrintServices"
                 placeholder="Nhà in"
                 (change)="updatePrintService(sellerCheck.sourceProduct.orderItemId ,sellerCheck.sourceProduct.wantedPrintService)"
                 [(ngModel)]="sellerCheck.sourceProduct.wantedPrintService">
      </ng-select>
    </div>
  </div>

  <!-- Tero SKU Selector -->
  <div class="form-group row" *ngIf="sellerCheck.sourceProduct.wantedPrintService === 'Tero'">
    <label class="col-sm-2 col-form-label">Chọn sản phẩm Tero:</label>
    <div class="col-sm-10">
      <ng-select class="text-left" 
                 [items]="teroProducts"
                 bindLabel="name"
                 placeholder="Chọn sản phẩm..."
                 (change)="onTeroProductSelected($event)"
                 [loading]="teroSkusLoading"
                 [clearable]="true"
                 [(ngModel)]="selectedTeroProduct">
        <ng-option *ngFor="let product of teroProducts" [value]="product">
          <strong>{{product.sku}}</strong> - {{product.name}}
          <br>
          <small class="text-muted">{{product.category?.name || 'No category'}}</small>
        </ng-option>
      </ng-select>
    </div>
  </div>

  <!-- Tero Shipping Type Selector -->
  <div class="form-group row" *ngIf="sellerCheck.sourceProduct.wantedPrintService === 'Tero'">
    <label class="col-sm-2 col-form-label">Loại vận chuyển Tero:</label>
    <div class="col-sm-10">
      <ng-select class="text-left" 
                 [items]="teroShippingTypes"
                 placeholder="Chọn loại vận chuyển..."
                 (change)="onTeroShippingTypeSelected($event)"
                 [clearable]="true"
                 [(ngModel)]="selectedTeroShippingType">
        <ng-option *ngFor="let shippingType of teroShippingTypes" [value]="shippingType">
          {{shippingType}}
        </ng-option>
      </ng-select>
    </div>
  </div>

  <!-- VTP Dimension and Merchandise -->
  <div class="form-group row" *ngIf="sellerCheck.sourceProduct.wantedPrintService === 'VTP'">
    <label class="col-sm-2 col-form-label">Weight (g)</label>
    <div class="col-sm-10">
      <input class="form-control" type="number" min="1" step="0.1"
             [(ngModel)]="vtpDimension.weight"
             (change)="onVtpDimensionChanged('weight')" />
    </div>
  </div>
  <div class="form-group row" *ngIf="sellerCheck.sourceProduct.wantedPrintService === 'VTP'">
    <label class="col-sm-2 col-form-label">Length</label>
    <div class="col-sm-10">
      <input class="form-control" type="number" min="0.1" step="0.1"
             [(ngModel)]="vtpDimension.length"
             (change)="onVtpDimensionChanged('length')" />
    </div>
  </div>
  <div class="form-group row" *ngIf="sellerCheck.sourceProduct.wantedPrintService === 'VTP'">
    <label class="col-sm-2 col-form-label">Width</label>
    <div class="col-sm-10">
      <input class="form-control" type="number" min="0.1" step="0.1"
             [(ngModel)]="vtpDimension.width"
             (change)="onVtpDimensionChanged('width')" />
    </div>
  </div>
  <div class="form-group row" *ngIf="sellerCheck.sourceProduct.wantedPrintService === 'VTP'">
    <label class="col-sm-2 col-form-label">Height</label>
    <div class="col-sm-10">
      <input class="form-control" type="number" min="0.1" step="0.1"
             [(ngModel)]="vtpDimension.height"
             (change)="onVtpDimensionChanged('height')" />
    </div>
  </div>

  <div class="form-group row" *ngIf="sellerCheck.sourceProduct.wantedPrintService === 'VTP'">
    <label class="col-sm-2 col-form-label">Item (SKU)</label>
    <div class="col-sm-10">
      <ng-select class="text-left"
                 [items]="vtpItems"
                 bindLabel="name"
                 placeholder="Mặc định: tên/SKU của đơn"
                 (change)="onVtpItemSelected($event)"
                 [clearable]="true"
                 [(ngModel)]="selectedVtpItem">
        <ng-template ng-option-tmp let-item="item">
          <strong>{{item.sku}}</strong> - {{item.name}}
        </ng-template>
      </ng-select>
    </div>
  </div>

  <div class="form-group row" *ngIf="sellerCheck.sourceProduct.wantedPrintService === 'VTP'">
    <label class="col-sm-2 col-form-label">Merchandise</label>
    <div class="col-sm-10">
      <ng-select class="text-left"
                 [items]="vtpMerchandise"
                 bindLabel="name"
                 placeholder="Chọn merchandise..."
                 (change)="onVtpMerchandiseSelected($event)"
                 (search)="onVtpMerchandiseSearch($event)"
                 [clearable]="true"
                 [searchable]="true"
                 [loading]="vtpLoading"
                 [(ngModel)]="selectedVtpMerchandise">
        <ng-template ng-option-tmp let-item="item">
          <strong>{{item.code}}</strong> - {{item.name}}
          <br>
          <small class="text-muted">{{item.parentName}}</small>
        </ng-template>
      </ng-select>
    </div>
  </div>

  <div class="form-group row" *ngIf="sellerCheck.sourceProduct.wantedPrintService === 'VTP'">
    <label class="col-sm-2 col-form-label">Line ship</label>
    <div class="col-sm-10">
      <ng-select class="text-left"
                 [items]="vtpLineShipPrices"
                 bindLabel="lineShipName"
                 placeholder="Chọn line ship..."
                 (change)="onVtpLineShipSelected($event)"
                 [clearable]="true"
                 [(ngModel)]="selectedVtpLineShip">
        <ng-option *ngFor="let ls of vtpLineShipPrices" [value]="ls">
          <strong>{{ls.lineShipName}}</strong> ({{ls.lineCode}}) - {{ls.price | number:'1.0-0'}} {{ls.currencyCode}}
          <span *ngIf="ls.priceUsd"> (~{{ls.priceUsd | number:'1.2-2'}} USD)</span>
        </ng-option>
      </ng-select>
    </div>
  </div>

  <!-- ISO order inputs -->
  <div class="form-group row" *ngIf="sellerCheck.sourceProduct.wantedPrintService === 'ISO'">
    <label class="col-sm-2 col-form-label">Service Id</label>
    <div class="col-sm-10">
      <ng-select class="text-left"
                 [items]="isoServices"
                 bindLabel="name"
                 placeholder="Chọn dịch vụ..."
                 (change)="onIsoServiceSelected($event)"
                 [clearable]="true"
                 [(ngModel)]="selectedIsoService">
        <ng-option *ngFor="let svc of isoServices" [value]="svc">
          <strong>{{svc.id}}</strong> - {{svc.name}}
        </ng-option>
      </ng-select>
    </div>
  </div>
  <div class="form-group row" *ngIf="sellerCheck.sourceProduct.wantedPrintService === 'ISO'">
    <label class="col-sm-2 col-form-label">Package name</label>
    <div class="col-sm-10">
      <input class="form-control" type="text"
             [(ngModel)]="isoOrderInput.packageName"
             (change)="onIsoFieldChanged('packageName')" />
    </div>
  </div>
  <div class="form-group row" *ngIf="sellerCheck.sourceProduct.wantedPrintService === 'ISO'">
    <label class="col-sm-2 col-form-label">Order item name</label>
    <div class="col-sm-10">
      <input class="form-control" type="text"
             [(ngModel)]="isoOrderInput.orderItemName"
             (change)="onIsoFieldChanged('orderItemName')" />
    </div>
  </div>
  <div class="form-group row" *ngIf="sellerCheck.sourceProduct.wantedPrintService === 'ISO'">
    <label class="col-sm-2 col-form-label">Length</label>
    <div class="col-sm-10">
      <input class="form-control" type="number" min="0" step="0.1"
             [(ngModel)]="isoOrderInput.length"
             (change)="onIsoFieldChanged('length')" />
    </div>
  </div>
  <div class="form-group row" *ngIf="sellerCheck.sourceProduct.wantedPrintService === 'ISO'">
    <label class="col-sm-2 col-form-label">Width</label>
    <div class="col-sm-10">
      <input class="form-control" type="number" min="0" step="0.1"
             [(ngModel)]="isoOrderInput.width"
             (change)="onIsoFieldChanged('width')" />
    </div>
  </div>
  <div class="form-group row" *ngIf="sellerCheck.sourceProduct.wantedPrintService === 'ISO'">
    <label class="col-sm-2 col-form-label">Height</label>
    <div class="col-sm-10">
      <input class="form-control" type="number" min="0" step="0.1"
             [(ngModel)]="isoOrderInput.height"
             (change)="onIsoFieldChanged('height')" />
    </div>
  </div>
  <div class="form-group row" *ngIf="sellerCheck.sourceProduct.wantedPrintService === 'ISO'">
    <label class="col-sm-2 col-form-label">Weight</label>
    <div class="col-sm-10">
      <input class="form-control" type="number" min="0" step="0.1"
             [(ngModel)]="isoOrderInput.weight"
             (change)="onIsoFieldChanged('weight')" />
    </div>
  </div>

  <!-- Custom SKU Selector -->
  <div class="form-group row" *ngIf="sellerCheck.sourceProduct.wantedPrintService === 'Tero' && availableCustomSkus && availableCustomSkus.length > 0">
    <label class="col-sm-2 col-form-label">Custom SKU:</label>
    <div class="col-sm-10">
      <ng-select class="text-left" 
                 [items]="availableCustomSkus"
                 bindLabel="displayText"
                 bindValue="custom_sku"
                 placeholder="Chọn Custom SKU..."
                 (change)="onCustomSkuSelected($event)"
                 [clearable]="true"
                 [(ngModel)]="sellerCheck.calculatedTeroCustomSku">
        <ng-option *ngFor="let variant of availableCustomSkus" [value]="variant.custom_sku">
          <strong>{{variant.custom_sku}}</strong> - Size: {{variant.size}}, Shipping: {{variant.shipping_type}}, Cost: ${{variant.cost}}
        </ng-option>
      </ng-select>
    </div>
  </div>

  <!-- HoGoToPod Product Selector -->
  <div class="form-group row" *ngIf="sellerCheck.sourceProduct.wantedPrintService === 'HoGoToPod'">
    <label class="col-sm-2 col-form-label">Chọn sản phẩm HoGoToPod:</label>
    <div class="col-sm-10">
      <ng-select class="text-left" 
                 [items]="hogotopodProducts"
                 bindLabel="name"
                 bindValue="code"
                 placeholder="Chọn sản phẩm..."
                 (change)="onHoGoToPodProductSelected($event)"
                 [clearable]="true"
                 [loading]="hogotopodProductsLoading"
                 [(ngModel)]="selectedHoGoToPodProduct">
        <ng-option *ngFor="let product of hogotopodProducts" [value]="product">
          <strong>{{product.code}}</strong> - {{product.name}}
          <br>
          <small class="text-muted">{{product.category?.name || 'No category'}}</small>
        </ng-option>
      </ng-select>
    </div>
  </div>

  <!-- HoGoToPod Color Selector -->
  <div class="form-group row" *ngIf="sellerCheck.sourceProduct.wantedPrintService === 'HoGoToPod' && availableHoGoToPodColors && availableHoGoToPodColors.length > 0">
    <label class="col-sm-2 col-form-label">Màu sắc:</label>
    <div class="col-sm-10">
      <ng-select class="text-left" 
                 [items]="availableHoGoToPodColors"
                 bindLabel="displayText"
                 bindValue="code"
                 placeholder="Chọn màu sắc..."
                 (change)="onHoGoToPodColorSelected($event)"
                 [clearable]="true"
                 [(ngModel)]="sellerCheck.calculatedHoGoToPodColorCode">
        <ng-option *ngFor="let color of availableHoGoToPodColors" [value]="color">
          <span [style.background-color]="color.color" [style.color]="color.color" class="color-preview">●</span>
          {{color.displayText}}
        </ng-option>
      </ng-select>
    </div>
  </div>

  <!-- HoGoToPod Size Selector -->
  <div class="form-group row" *ngIf="sellerCheck.sourceProduct.wantedPrintService === 'HoGoToPod' && availableHoGoToPodSizes && availableHoGoToPodSizes.length > 0">
    <label class="col-sm-2 col-form-label">Kích thước:</label>
    <div class="col-sm-10">
      <ng-select class="text-left" 
                 [items]="availableHoGoToPodSizes"
                 bindLabel="displayText"
                 bindValue="size"
                 placeholder="Chọn kích thước..."
                 (change)="onHoGoToPodSizeSelected($event)"
                 [clearable]="true"
                 [(ngModel)]="sellerCheck.calculatedHoGoToPodSize">
        <ng-option *ngFor="let size of availableHoGoToPodSizes" [value]="size">
          {{size.displayText}}
        </ng-option>
      </ng-select>
    </div>
  </div>

  <!-- HoGoToPod Position Selector -->
  <div class="form-group row" *ngIf="sellerCheck.sourceProduct.wantedPrintService === 'HoGoToPod' && availableHoGoToPodPositions && availableHoGoToPodPositions.length > 0">
    <label class="col-sm-2 col-form-label">Vị trí in:</label>
    <div class="col-sm-10">
      <ng-select class="text-left" 
                 [items]="availableHoGoToPodPositions"
                 bindLabel="displayText"
                 bindValue="code"
                 placeholder="Chọn vị trí in..."
                 (change)="onHoGoToPodPositionSelected($event)"
                 [clearable]="true"
                 [(ngModel)]="sellerCheck.calculatedHoGoToPodPositionCode">
        <ng-option *ngFor="let position of availableHoGoToPodPositions" [value]="position">
          {{position.displayText}}
        </ng-option>
      </ng-select>
    </div>
  </div>


  <div class="form-group row" *ngIf="sellerCheck.sourceProduct.wantedPrintService == 'Flashship' || sellerCheck.sourceProduct.wantedPrintService == 'Flashship Ornament'">
    <label class="col-sm-2 col-form-label">Loại áo FlashShip</label>
    <div class="col-sm-10">
      <ng-select class="text-left" [items]="sellerCheck.availableFlashShipShirtTypes"
                 placeholder="Loại áo Flashship"
                 (change)="updateVariantInfo(sellerCheck.sourceProduct.orderItemId, 'FlashShipShirt', sellerCheck.calculatedFlashShipShirtType)"
                 [(ngModel)]="sellerCheck.calculatedFlashShipShirtType">
      </ng-select>
    </div>
  </div>

  <div class="form-group row" *ngIf="sellerCheck.sourceProduct.wantedPrintService == 'Merchize'">
    <label class="col-sm-2 col-form-label">Loại áo Merchize</label>
    <div class="col-sm-10">
      <ng-select class="text-left" [items]="sellerCheck.availableMerchizeShirtTypes"
                 placeholder="Loại áo Merchize"
                 (change)="updateVariantInfo(sellerCheck.sourceProduct.orderItemId, 'merchize', sellerCheck.calculatedMerchizeShirtType)"
                 [(ngModel)]="sellerCheck.calculatedMerchizeShirtType">
      </ng-select>
    </div>
  </div>

  <div class="form-group row" *ngIf="sellerCheck.sourceProduct.wantedPrintService == 'Printify'">
    <label class="col-sm-2 col-form-label">Loại áo Printify</label>
    <div class="col-sm-10">
      <ng-select class="text-left" [items]="blueprints"
                 placeholder="Loại áo Printify"
                 bindValue="id"
                 bindLabel="title"
                 (change)="updateVariantInfo(sellerCheck.sourceProduct.orderItemId, 'printifyBlueprint', sellerCheck.calculatedPrintifyBlueprintId)"
                 [(ngModel)]="sellerCheck.calculatedPrintifyBlueprintId">
      </ng-select>
    </div>
  </div>

  <div class="form-group row" *ngIf="sellerCheck.sourceProduct.wantedPrintService == 'Printify'">
    <label class="col-sm-2 col-form-label">Nhà in Printify</label>
    <div class="col-sm-10">
      <ng-select class="text-left" [items]="printifyProviders"
                 placeholder="Nhà in Printify"
                 bindValue="id"
                 bindLabel="title"
                 (change)="updateVariantInfo(sellerCheck.sourceProduct.orderItemId, 'printifyProvider', sellerCheck.calculatedPrintifyProviderId)"
                 [(ngModel)]="sellerCheck.calculatedPrintifyProviderId">
      </ng-select>
    </div>
  </div>

  <div class="form-group row" *ngIf="sellerCheck.sourceProduct.wantedPrintService == 'Printcare'">
    <label class="col-sm-2 col-form-label">Loại áo Printcare</label>
    <div class="col-sm-10">
      <ng-select class="text-left" [items]="sellerCheck.availableBestPrintCareShirtTypes"
                 placeholder="Loại áo Printcare"
                 (change)="updateVariantInfo(sellerCheck.sourceProduct.orderItemId, 'bestprintcare', sellerCheck.calculatedBestPrintCareShirtType)"
                 [(ngModel)]="sellerCheck.calculatedBestPrintCareShirtType">
      </ng-select>
    </div>
  </div>

  <div class="form-group row" *ngIf="sellerCheck.sourceProduct.wantedPrintService == 'ATD'">
    <label class="col-sm-2 col-form-label">Dài (ATD)</label>
    <div class="col-sm-10">
      <input type="text" class="form-control" [(ngModel)]="sellerCheck.atdLength"
             (change)="updateVariantInfo(sellerCheck.sourceProduct.orderItemId, 'atdLength', sellerCheck.atdLength)" />
    </div>
  </div>

  <div class="form-group row" *ngIf="sellerCheck.sourceProduct.wantedPrintService == 'ATD'">
    <label class="col-sm-2 col-form-label">Rộng (ATD)</label>
    <div class="col-sm-10">
      <input type="text" class="form-control" [(ngModel)]="sellerCheck.atdWidth"
             (change)="updateVariantInfo(sellerCheck.sourceProduct.orderItemId, 'atdWidth', sellerCheck.atdWidth)" />
    </div>
  </div>

  <div class="form-group row" *ngIf="sellerCheck.sourceProduct.wantedPrintService == 'ATD'">
    <label class="col-sm-2 col-form-label">Cao (ATD)</label>
    <div class="col-sm-10">
      <input type="text" class="form-control" [(ngModel)]="sellerCheck.atdHeight"
             (change)="updateVariantInfo(sellerCheck.sourceProduct.orderItemId, 'atdHeight', sellerCheck.atdHeight)" />
    </div>
  </div>

  <div class="form-group row" *ngIf="sellerCheck.sourceProduct.wantedPrintService == 'ATD'">
    <label class="col-sm-2 col-form-label">Nặng (ATD)</label>
    <div class="col-sm-10">
      <input type="text" class="form-control" [(ngModel)]="sellerCheck.atdWeight"
             (change)="updateVariantInfo(sellerCheck.sourceProduct.orderItemId, 'atdWeight', sellerCheck.atdWeight)" />
    </div>
  </div>

  <div class="form-group row" *ngIf="sellerCheck.sourceProduct.wantedPrintService == 'ATD'">
    <label class="col-sm-2 col-form-label">Loại SP (ATD)</label>
    <div class="col-sm-10">
      <ng-select class="text-left" [items]="sellerCheck.availableAtdProductTypes"
                 placeholder="Loại SP (ATD)"
                 (change)="updateVariantInfo(sellerCheck.sourceProduct.orderItemId, 'atdProductType', sellerCheck.atdProductType)"
                 [(ngModel)]="sellerCheck.atdProductType">
      </ng-select>

    </div>
  </div>

  <div class="form-group row" *ngIf="sellerCheck.sourceProduct.wantedPrintService == 'ATD'">
    <label class="col-sm-2 col-form-label">Chất liệu (ATD)</label>
    <div class="col-sm-10">
      <ng-select class="text-left" [items]="sellerCheck.availableAtdPProductMaterials"
                 placeholder="Chất liệu (ATD)"
                 (change)="updateVariantInfo(sellerCheck.sourceProduct.orderItemId, 'atdProductMaterial', sellerCheck.atdProductMaterial)"
                 [(ngModel)]="sellerCheck.atdProductMaterial">
      </ng-select>
    </div>
  </div>

  <div class="form-group row" *ngIf="sellerCheck.sourceProduct.wantedPrintService == 'ATD'">
    <label class="col-sm-2 col-form-label">Tên SP (ATD)</label>
    <div class="col-sm-10">
      <input type="text" class="form-control" [(ngModel)]="sellerCheck.atdProductName"
             (change)="updateVariantInfo(sellerCheck.sourceProduct.orderItemId, 'atdProductName', sellerCheck.atdProductName)" />
    </div>
  </div>

  <div class="form-group row" *ngIf="sellerCheck.sourceProduct.wantedPrintService == 'ATD'">
    <label class="col-sm-2 col-form-label">Line (ATD)</label>
    <div class="col-sm-10">
      <ng-select class="text-left" [items]="atdLineOptions" bindLabel="label" bindValue="value"
                 placeholder="Select Line (ATD)"
                 (change)="updateVariantInfo(sellerCheck.sourceProduct.orderItemId, 'atdLine', sellerCheck.atdLine)"
                 [(ngModel)]="sellerCheck.atdLine">
      </ng-select>
    </div>
  </div>

  <!--<div class="form-group row" *ngIf="sellerCheck.sourceProduct.wantedPrintService == 'Zenith'">
    <label class="col-sm-2 col-form-label">Zenith SKU</label>
    <div class="col-sm-10">
      <input type="text" class="form-control" [(ngModel)]="sellerCheck.zenithSku"
             (change)="updateVariantInfo(sellerCheck.sourceProduct.orderItemId, 'zenithSku', sellerCheck.zenithSku)" />
    </div>
  </div>-->

  <div class="form-group row" *ngIf="sellerCheck.sourceProduct.wantedPrintService == 'Zenith'">
    <label class="col-sm-2 col-form-label">Zenith SKU</label>
    <div class="col-sm-10">
      <ng-select [items]="zenithProducts" bindLabel="name" bindValue="name" [(ngModel)]="sellerCheck.zenithSku"
                 (change)="updateVariantInfo(sellerCheck.sourceProduct.orderItemId, 'zenithSku', sellerCheck.zenithSku)">
        <ng-template ng-label-tmp let-item="item">
          <div class="custom-label">
            <img [src]="'https://api.zenith.top/' + item?.images[item?.images?.length - 1]" alt="Product Image" width="80" height="80" />
            {{ item?.name }}
          </div>
        </ng-template>
        <ng-template ng-option-tmp let-item="item" let-index="index">
          <div class="custom-option">
            <img [src]="'https://api.zenith.top/' + item?.images[item?.images?.length - 1]" alt="Product Image" width="80" height="80" />
            <span>{{ item?.name }}</span>
          </div>
        </ng-template>
      </ng-select>
    </div>
  </div>


  <div class="form-group row" *ngIf="sellerCheck.sourceProduct.wantedPrintService == 'Zenith'">
    <label class="col-sm-2 col-form-label">Zenith Note</label>
    <div class="col-sm-10">
      <input type="text" class="form-control" [(ngModel)]="sellerCheck.zenithNote"
             (change)="updateVariantInfo(sellerCheck.sourceProduct.orderItemId, 'zenithNote', sellerCheck.zenithNote)" />
    </div>
  </div>

  <div class="form-group row" *ngIf="sellerCheck.sourceProduct.wantedPrintService == 'Printposs'">
    <label class="col-sm-2 col-form-label">Printposs Sản phẩm / SKU</label>
    <div class="col-sm-10">
      <ng-select [items]="printpossVariants" bindLabel="label" [loading]="printpossVariantsLoading"
                 placeholder="Chọn sản phẩm Printposs (lấy trực tiếp từ API)"
                 [ngModel]="findPrintpossVariant(sellerCheck.printpossSku)"
                 (change)="onPrintpossVariantSelected($event)">
      </ng-select>
      <small class="form-text text-muted">Danh sách lấy trực tiếp từ Printposs API (GET /api/v1/seller/products), không hard code.</small>
    </div>
  </div>

  <div class="form-group row" *ngIf="sellerCheck.sourceProduct.wantedPrintService == 'Hd Sticker'">
    <label class="col-sm-2 col-form-label">Sản phẩm Hd Sticker</label>
    <div class="col-sm-10">
      <ng-select class="text-left" [items]="hdStikerProductNames"
                 placeholder="Sản phẩm Hd Sticker"
                 (change)="updateVariantInfo(sellerCheck.sourceProduct.orderItemId, 'HdStickerProductName', sellerCheck.hdStickerProductName)"
                 [(ngModel)]="sellerCheck.hdStickerProductName">
      </ng-select>
    </div>
  </div>

  <div class="form-group row">
    <label class="col-sm-2 col-form-label">Size</label>
    <div class="col-sm-10">
      <ng-select class="text-left" [items]="sellerCheck.availableSizes"
                 placeholder="Size"
                 [addTag]="true"
                 [addTagText]="'Add custom size: '"
                 (add)="onAddCustomSize($event)"
                 (change)="onSizeChange($event)"
                 [searchable]="true"
                 [(ngModel)]="sellerCheck.calculatedSize">
      </ng-select>
    </div>
  </div>

  <div class="form-group row">
    <label class="col-sm-2 col-form-label">Màu</label>
    <div class="col-sm-10">
      <ng-select class="text-left" [items]="sellerCheck.availableColors"
                 placeholder="Màu"
                 (change)="updateVariantInfo(sellerCheck.sourceProduct.orderItemId, 'color', sellerCheck.calculatedColor)"
                 [(ngModel)]="sellerCheck.calculatedColor">
      </ng-select>
    </div>
  </div>

  <div class="form-group row" *ngIf="sellerCheck.sourceProduct.wantedPrintService == 'Onos'">
    <label class="col-sm-2 col-form-label">Sản phẩm Onos</label>
    <div class="col-sm-10">
      <ng-select class="text-left" [items]="onosProducts"
                 placeholder="Sản phẩm Onos"
                 (change)="updateVariantInfo(sellerCheck.sourceProduct.orderItemId, 'onos_sku', sellerCheck.calculatedOnosSku)"
                 [(ngModel)]="sellerCheck.calculatedOnosSku">
      </ng-select>
    </div>
  </div>

  <div class="form-group row" *ngIf="sellerCheck.sourceProduct.wantedPrintService == 'Gearment'">
    <label class="col-sm-2 col-form-label">Sản phẩm Gearment</label>
    <div class="col-sm-10">
      <ng-select class="text-left" [items]="gearmentProducts"
                 bindLabel="product_name"
                 bindValue="product_id"
                 placeholder="Sản phẩm Gearment"
                 (change)="updateGearmentProduct()"
                 [(ngModel)]="sellerCheck.calculatedGearmentProductId">
      </ng-select>
    </div>
  </div>

  <div class="form-group row" *ngIf="sellerCheck.sourceProduct.wantedPrintService == 'Gearment'">
    <label class="col-sm-2 col-form-label">Biến thể Gearment</label>
    <div class="col-sm-10">
      <ng-select class="text-left" [items]="gearmentVariants"
                 bindLabel="name"
                 bindValue="variant_id"
                 placeholder="Biến thể Gearment"
                 (change)="updateVariantInfo(sellerCheck.sourceProduct.orderItemId, 'gearment_variant_id', sellerCheck.calculatedGearmentVariantId)"
                 [(ngModel)]="sellerCheck.calculatedGearmentVariantId">
      </ng-select>
    </div>
  </div>

  <div class="form-group row" *ngIf="sellerCheck.sourceProduct.wantedPrintService == 'Printcare'">
    <label class="col-sm-2 col-form-label">Tiền Label</label>
    <div class="col-sm-10">
      <input [disabled]="sellerCheck.currentRecord.progressState != 20" type="number" class="form-control"
             [(ngModel)]="sellerCheck.calculatedFulfillLabelPrice"
             (change)="updateFulfillLabelPrice(sellerCheck.sourceProduct.orderItemId, sellerCheck.calculatedFulfillLabelPrice)">

    </div>
  </div>
  <div class="form-group row" *ngIf="sellerCheck.sourceProduct.isPrepaidLabel">
    <label class="col-sm-2 col-form-label">Tracking Trả Trước</label>
    <div class="col-sm-10">
      {{sellerCheck.sourceProduct.trackingNumber}}

    </div>
  </div>
  <div class="form-group row" *ngIf="sellerCheck.sourceProduct.isPrepaidLabel">
    <label class="col-sm-2 col-form-label">Link Label Tracking Trả Trước</label>
    <div class="col-sm-10">
      {{sellerCheck.sourceProduct.shippingLabelLink}}

    </div>
  </div>

  <div class="form-group row">
    <label class="col-sm-2 col-form-label">Giá tiền sản phẩm</label>
    <div class="col-sm-10">
      <input [disabled]="sellerCheck.currentRecord.progressState != 20" type="number" class="form-control"
             [(ngModel)]="sellerCheck.sourceProduct.productPrice"
             (change)="syncSellerCheckPrice(sellerCheck.sourceProduct, 'productPrice')">
    </div>
  </div>
  <div class="form-group row">
    <label class="col-sm-12">
      *Có {{sellerCheck.otherRecordForSourceOrderCount}} sản phẩm khác trong cùng một đơn nguồn, điền
      thông tin vào ô dưới nếu muốn đồng bộ thông tin cho đơn nguồn
    </label>
    <label class="col-sm-2 col-form-label">Giá tiền toàn bộ đơn</label>
    <div class="col-sm-10">
      <input type="number" class="form-control" [disabled]="sellerCheck.currentRecord.progressState != 20"
             [(ngModel)]="sellerCheck.sourceProduct.orderPrice"
             (change)="syncSellerCheckPrice(sellerCheck.sourceProduct, 'orderPrice')">
    </div>
  </div>

  <div class="form-group row"
       *ngIf="sellerCheck.currentRecord.progressState >= 20 || sellerCheck.currentRecord.progressState == 5">
    <label class="col-sm-2 col-form-label">Mã Tracking</label>
    <div class="col-sm-10">
      <input [disabled]="sellerCheck.currentRecord.progressState != 30
                          && sellerCheck.currentRecord.progressState != 20" type="text" class="form-control"
             (focusout)="updateSingleValue(sellerCheck.currentRecord, 'TrackingNumber', sellerCheck.sourceProduct.trackingNumber)"
             [(ngModel)]="sellerCheck.sourceProduct.trackingNumber">
    </div>
  </div>

  <div class="form-group row">
    <div class="col-sm-6" *ngIf="sellerCheck.sourceProduct.wantedPrintService == 'Flashship'">
      <button class="btn btn-info" (click)="buyFlashshipByApi()"
              *ngIf="sellerCheck.currentRecord.progressState == 20">
        <i class="fas fa-cash-register"></i>
        Mua bằng API
      </button>
    </div>
    <div class="col-sm-6" *ngIf="sellerCheck.sourceProduct.wantedPrintService == 'Printcare'">
      <button class="btn btn-info" (click)="buyPrintCareByApi()"
              *ngIf="sellerCheck.currentRecord.progressState == 20">
        <i class="fas fa-cash-register"></i>
        Mua bằng API
      </button>
    </div>
    <div class="col-sm-6" *ngIf="sellerCheck.sourceProduct.wantedPrintService == 'Onos'">
      <button class="btn btn-info" (click)="sendOrderOnosApi()"
              *ngIf="sellerCheck.currentRecord.progressState == 20">
        <i class="fas fa-cash-register"></i>
        Mua bằng API
      </button>
    </div>
    <div class="col-sm-6" *ngIf="sellerCheck.sourceProduct.wantedPrintService == 'ISO'">
      <button class="btn btn-info" (click)="sendOrderIsoApi()"
              *ngIf="sellerCheck.currentRecord.progressState == 20">
        <i class="fas fa-cash-register"></i>
        Mua bằng API
      </button>
    </div>
    <div class="col-sm-6" *ngIf="sellerCheck.sourceProduct.wantedPrintService == 'Printposs'">
      <button class="btn btn-info" (click)="sendOrderPrintpossApi()"
              *ngIf="sellerCheck.currentRecord.progressState == 20">
        <i class="fas fa-cash-register"></i>
        Mua bằng API
      </button>
    </div>
    <div class="col-sm-6" *ngIf="sellerCheck.sourceProduct.wantedPrintService == 'ATD'">
      <button class="btn btn-info" (click)="sendOrderAtdApi()"
              *ngIf="sellerCheck.currentRecord.progressState == 20">
        <i class="fas fa-cash-register"></i>
        Mua bằng API
      </button>
    </div>
    <div class="col-sm-6" *ngIf="sellerCheck.sourceProduct.wantedPrintService == 'Gearment'">
      <button class="btn btn-info" (click)="sendOrderGearmentApi()"
              *ngIf="sellerCheck.currentRecord.progressState == 20">
        <i class="fas fa-cash-register"></i>
        Mua bằng API
      </button>
    </div>
    <div class="col-sm-6" *ngIf="sellerCheck.sourceProduct.wantedPrintService == 'Zenith'">
      <button class="btn btn-info" (click)="sendOrderZenithApi()"
              *ngIf="sellerCheck.currentRecord.progressState == 20">
        <i class="fas fa-cash-register"></i>
        Mua bằng API
      </button>
    </div>
    <div class="col-sm-6" *ngIf="sellerCheck.sourceProduct.wantedPrintService == 'Hd Sticker'">
      <button class="btn btn-info" (click)="sendOrderHdStickerApi()"
              *ngIf="sellerCheck.currentRecord.progressState == 20">
        <i class="fas fa-cash-register"></i>
        Mua bằng API
      </button>
    </div>
    <div class="col-sm-6" *ngIf="sellerCheck.sourceProduct.wantedPrintService == 'Tero'">
      <button class="btn btn-info" (click)="sendOrderTeroApi()"
              *ngIf="sellerCheck.currentRecord.progressState == 20">
        <i class="fas fa-cash-register"></i>
        Mua bằng API
      </button>
    </div>
    <div class="col-sm-6" *ngIf="sellerCheck.sourceProduct.wantedPrintService == 'VTP'">
      <button class="btn btn-info" (click)="sendOrderVtpApi()"
              *ngIf="sellerCheck.currentRecord.progressState == 20">
        <i class="fas fa-cash-register"></i>
        Mua bằng API
      </button>
    </div>
    <div class="col-sm-6" *ngIf="sellerCheck.sourceProduct.wantedPrintService == 'HoGoToPod'">
      <button class="btn btn-info" (click)="sendOrderHoGoToPodApi()"
              *ngIf="sellerCheck.currentRecord.progressState == 20">
        <i class="fas fa-cash-register"></i>
        Mua bằng API
      </button>
    </div>
    <div class="col-sm-6" *ngIf="sellerCheck.sourceProduct.wantedPrintService == 'Printify'">
      <button class="btn btn-info" (click)="buyPrintifyByApi()"
              *ngIf="sellerCheck.currentRecord.progressState == 20">
        <i class="fas fa-cash-register"></i>
        Mua bằng API
      </button>
    </div>
    <div class="col-sm-6" *ngIf="sellerCheck.sourceProduct.wantedPrintService == 'Printify'
                                || sellerCheck.sourceProduct.wantedPrintService == 'Flashship'
                                || sellerCheck.sourceProduct.wantedPrintService == 'Onos'
                                || sellerCheck.sourceProduct.wantedPrintService == 'ATD'
                                || sellerCheck.sourceProduct.wantedPrintService == 'Gearment'
                                || sellerCheck.sourceProduct.wantedPrintService == 'Printcare'
                                || sellerCheck.sourceProduct.wantedPrintService == 'Zenith'
                                || sellerCheck.sourceProduct.wantedPrintService == 'Hd Sticker'
                                || sellerCheck.sourceProduct.wantedPrintService == 'Tero'
                                || sellerCheck.sourceProduct.wantedPrintService == 'HoGoToPod'
                                || sellerCheck.sourceProduct.wantedPrintService == 'VTP'
                                || sellerCheck.sourceProduct.wantedPrintService == 'ISO'
                                || sellerCheck.sourceProduct.wantedPrintService == 'Printposs'
       ">
      <button class="btn btn-info" (click)="confirmBuy()"
              *ngIf="sellerCheck.currentRecord.progressState == 20">
        <i class="fas fa-cash-register"></i>
        Xác nhận thông tin mua hàng
      </button>
    </div>
    <div class="col-sm-12" *ngIf="sellerCheck.sourceProduct.wantedPrintService != 'Printify'
                              && sellerCheck.sourceProduct.wantedPrintService != 'Flashship'
                              && sellerCheck.sourceProduct.wantedPrintService != 'Onos'
                              && sellerCheck.sourceProduct.wantedPrintService != 'ATD'
                              && sellerCheck.sourceProduct.wantedPrintService != 'Gearment'
                              && sellerCheck.sourceProduct.wantedPrintService != 'Printcare'
                              && sellerCheck.sourceProduct.wantedPrintService != 'Zenith'
                              && sellerCheck.sourceProduct.wantedPrintService != 'Tero'
                              && sellerCheck.sourceProduct.wantedPrintService != 'Hd Sticker'
                              && sellerCheck.sourceProduct.wantedPrintService != 'HoGoToPod'
                              && sellerCheck.sourceProduct.wantedPrintService != 'VTP'
                              && sellerCheck.sourceProduct.wantedPrintService != 'ISO'
                              && sellerCheck.sourceProduct.wantedPrintService != 'Printposs'
       ">
      <button class="btn btn-info" (click)="confirmBuy()"
              *ngIf="sellerCheck.currentRecord.progressState == 20">
        <i class="fas fa-cash-register"></i>
        Xác nhận thông tin mua hàng
      </button>
    </div>
  </div>


  <div class="form-group row">
    <div class="col-sm-12">
      <button class="btn btn-success" (click)="confirmTracking()"
              *ngIf="sellerCheck.currentRecord.progressState == 30">
        <i class="fas fa-truck-loading"></i>
        Xác nhận mã tracking
      </button>
    </div>
  </div>

  <div class="form-group row">
    <div class="col-sm-12">
      <button class="btn btn-primary" (click)="confirmTrackingAccount()"
              *ngIf="sellerCheck.currentRecord.progressState == 35">
        <i class="fas fa-truck-loading"></i>
        Xác nhận trả mã tracking vào TK
      </button>
    </div>
  </div>

  <div class="form-group row">
    <div class="col-sm-12">
      <button class="btn btn-primary" (click)="confirmTrackingDone()"
              *ngIf="sellerCheck.currentRecord.progressState == 40">
        <i class="fas fa-truck"></i>
        Xác nhận đơn hàng đã giao thành công
      </button>
    </div>
  </div>

</div>
</div>
</div>
</div>
</div>
</div>


</div>
</ng-template>

<ng-template #exportPrinityShirtModal let-modal>
  <div class="modal-lg">
    <div class="modal-header">
      <h4 class="modal-title" id="modal-basic-title">Export Printify Shirts</h4>
    </div>
    <div class="modal-body">
      <div class="form-group">
        <select class="form-control" [(ngModel)]="printifyExport.providerId">
          <option value="">Please Select Print Provider</option>
          <option *ngFor="let provider of printifyProviders" [value]="provider.printifyId">{{ provider.providerName }}
          </option>
        </select>
      </div>
      <div class="form-group">
        <select class="form-control" [(ngModel)]="printifyExport.productId">
          <option value="">Please Select Product</option>
          <option *ngFor="let product of printifyProducts" [value]="product.printifyId">{{ product.productName }}
          </option>
        </select>
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-outline-primary" (click)="downloadExportFileForPrintify()">Ok</button>
    </div>
  </div>
</ng-template>


<ng-template #content let-modal>
  <div class="modal-header">
    <h4 class="modal-title">Modal title</h4>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <p>One fine body&hellip;</p>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-light" (click)="modal.close('Close click')">Close</button>
  </div>
</ng-template>

<ng-template #deleteSaleRecordModal let-modal>
  <div class="modal-header">
    <h4 class="modal-title">Confirm Delete</h4>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    Are you sure want to delete sale record: {{deletedSaleRecord.productName}}
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-light" (click)="modal.close('Close click')">No</button>
    <button type="button" class="btn btn-light btn-danger" (click)="deleteSaleRecord()">Yes</button>
  </div>
</ng-template>

<ng-template #importSaleRecordModal let-modal>
  <div class="modal-header">
    <h4 class="modal-title">Import Đơn Etsy/Ebay</h4>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    Nhóm
    <select class="form-control" [class.hasError]="uploadToMerchantGroupId==''" [(ngModel)]="uploadToMerchantGroupId">
      <option value="">Nếu có tài khoản mới, sẽ được thêm vào team</option>
      <option *ngFor="let group of merchantGroups" [value]="group.id">{{ group.name }}</option>
    </select>

    Tài khoản
    <ng-select [class.hasError]="!uploadToMerchantId"
               [items]="etsyMerchants"
               [multiple]="false"
               placeholder="Chọn Tài Khoản"
               bindValue="merchantId"
               bindLabel="name"
               [closeOnSelect]="true"
               [(ngModel)]="uploadToMerchantId"
               name="accountName">
    </ng-select>

    <input class="mt-10 mb-4" type="file" multiple="true" (change)="uploadImportFile($event.target.files)">
    <div class="progress mt-10" *ngIf="uploadImportFileProgress">
      <div class="progress-bar" [style.width]="uploadImportFileProgress + '%'">
        {{uploadImportFileProgress}}%
      </div>
    </div>
    <p class="mt-10" *ngFor="let message of importMessages">
      {{message}}
    </p>
  </div>
</ng-template>

